export const shiftTabToLastElement = (evt, lastFocusElementId) => {
  // Metod för att fånga tabbning tillbaka i en modal
  if (evt.keyCode === 9 && evt.shiftKey) {
    evt.preventDefault();

    const lastFocusElement = document.getElementById(lastFocusElementId);
    lastFocusElement.focus();
  }
};
export const tabToFirstElement = (evt, firstFocusElementId) => {
  // Metod för att fånga tabbning i en modal
  if (evt.keyCode === 9 && !evt.shiftKey) {
    evt.preventDefault();

    const firstFocusElement = document.getElementById(firstFocusElementId);
    firstFocusElement.focus();
  }
};
